import instance from '@platform/shared/rpc/node/axios.instance';

import * as Api from './api.gen';
import { default as Rpc } from './rpc-wrapper';
import { default as Events } from './events-wrapper';

Api.serviceOptions.axios = instance;

const NodeAPI = {
    ...Api,
    Rpc,
    Events,
} as typeof Api & { Rpc: typeof Rpc; Events: typeof Events };

export { NodeAPI };
